// Care Management > Overview sub-pages. The sub-page is a path segment
// named after its label (/caremanagement/overview/outreach-operations), not a
// hash; the key is what CareManagement_Overview uses internally.
export const OVERVIEW_SECTIONS = {
  operations: 'daily-operations',
  ct_operations: 'care-transitions-operations',
  outreach_operations: 'outreach-operations',
  complex_care_operations: 'complex-care-operations',
  discharge_waterfall: 'discharge-waterfall',
  pipeline: 'pipeline',
  episode_grouper: 'episode-grouper',
  delivery_report: 'messaging-delivery-report',
};

const SLUG_TO_KEY = Object.fromEntries(Object.entries(OVERVIEW_SECTIONS).map(([key, slug]) => [slug, key]));

export const overviewSectionKey = (slug) => SLUG_TO_KEY[slug] || null;

export const overviewLocation = (key) => ({
  name: 'CareManagement-Operations',
  params: { section: OVERVIEW_SECTIONS[key] || OVERVIEW_SECTIONS.operations },
});

export function overviewRoutes(component, props) {
  return [
    // The tab itself lands on its default sub-page, as Hermes does.
    { path: '/caremanagement/overview', redirect: overviewLocation('operations') },
    {
      // The route name is kept from the old /caremanagement/operations route:
      // usage reporting (kaironlibrary customer-usage-report skill) groups by it.
      path: `/caremanagement/overview/:section(${Object.values(OVERVIEW_SECTIONS).join('|')})`,
      name: 'CareManagement-Operations',
      component,
      props,
      meta: { requiresAuth: true, layout: 'default' },
    },
  ];
}

// Care Management > QA. The path names the place: the report, one care
// manager's scorecard, one graded call, the audit queue, one call being
// audited. Ids are numeric (or a call uuid for audits) so the router rejects
// nonsense. Route names are kept from the old routes for usage reporting.
export const qaReportLocation = (cmUserId = null, workId = null) => {
  if (cmUserId && workId) return { name: 'CareManagement-QA-Report-Call', params: { cmUserId, workId } };
  if (cmUserId) return { name: 'CareManagement-QA-Report', params: { cmUserId } };
  return { name: 'CareManagement-QA-Report' };
};

export const qaAuditLocation = (sessionId = null) =>
  sessionId ? { name: 'CareManagement-QA-AuditCalls', params: { sessionId } } : { name: 'CareManagement-QA-AuditCalls' };

export function qaRoutes(component, meta) {
  const reportProps = (route) => ({
    activeTab: 'QA',
    qaMode: 'report',
    qaCmUserId: route.params.cmUserId ? Number(route.params.cmUserId) : null,
    qaWorkId: route.params.workId ? Number(route.params.workId) : null,
  });
  return [
    { path: '/caremanagement/qa', redirect: qaReportLocation(), meta },
    { path: '/caremanagement/qa/report/:cmUserId(\\d+)?', name: 'CareManagement-QA-Report', component, props: reportProps, meta },
    { path: '/caremanagement/qa/report/:cmUserId(\\d+)/calls/:workId(\\d+)', name: 'CareManagement-QA-Report-Call', component, props: reportProps, meta },
    {
      path: '/caremanagement/qa/audit-calls/:sessionId?',
      name: 'CareManagement-QA-AuditCalls',
      component,
      props: (route) => ({ activeTab: 'QA', qaMode: 'audit', qaSessionId: route.params.sessionId || null }),
      meta,
    },
  ];
}
